import React, { createContext, useContext, useEffect, useState } from "react";
import api, { setToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Legacy shared session key — removed so panels never share a session.
    try { localStorage.removeItem("access_token"); } catch {}
    refresh();
    // Keep balance/profile fresh while signed in.
    const id = setInterval(() => {
      if (document.visibilityState !== "visible") return;
      api.get("/auth/me").then(({ data }) => setUser((u) => (u ? data.user : u))).catch(() => {});
    }, 8000);
    return () => clearInterval(id);
  }, []);

  const login = async (email, password, scope = "merchant") => {
    const { data } = await api.post("/auth/login", { email, password, scope });
    setToken(data.access_token, scope === "admin" ? "admin" : "seller");
    setUser(data.user);
    return data.user;
  };


  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setToken(data.access_token, "seller");
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
